import Vue from 'vue'

import "@/global/index"

// 引入该页面个性化UI组件
import {
    Card, MessageBox
} from 'element-ui';

Vue.use(Card)

Object.defineProperty(Vue.prototype, '$alert', { value: MessageBox.alert })
Object.defineProperty(Vue.prototype, '$confirm', { value: MessageBox.confirm })

import store from '@/store/global-store'
import App from './App'
new Vue({
    store,
    render: h => h(App),
    created: function () {

    }
}).$mount('#app')


// WEBPACK FOOTER //
// ./src/seeker/jobfair/detail/jobfair_detail.js